document.addEventListener("readystatechange", (event) => {
  if (event.target.readyState === "complete") {
    if (!$.cookie('cc_detect_cookies')) {
      (function($) {
        $.ajax({
            url: ajaxurl,
            type: 'GET',
            headers: {
                'Cache-control': 'max-age=84600, public',
                'Pragma': 'cache'
            },
            cache: true,
            data: {
                action: 'detect_if_accept_cookies_php',
                acceptCookie: navigator.cookieEnabled,
                ver: '1.0.0' // version number for cache busting
            },
            success: $.cookie('cc_detect_cookies', 'true')
        });
      })(jQuery); // Using jQuery for AJAX
    }else{
      console.log('Cookie is already set');
    }
  }
});
